import { Link, useNavigate } from "react-router-dom";
import { Container, Stack, Button } from '@mui/material'


/**
 * よくあるご質問
 * @returns
 */

const G0221Question = () => {
	return (
		<><div class="mainLinkMenu"></div>
			<div id="homeContents">
				<div class="homeContentsInner">
					<div class="mainCont">
						<div class="selectSearchArea">
							<Container maxWidth="lg">
								<Stack spacing={2}>

									<h1>よくあるご質問</h1>

									<Button component={Link} to={"/G0222QuestionCategoryList"}
										style={{ width: "200px", color: "white", textDecoration: "none" }}>
										質問カテゴリー
									</Button>

									<Button component={Link} to={"/G0224QuestionList"}
										style={{ width: "200px", color: "white", textDecoration: "none" }}>
										質問内容
									</Button>

								</Stack>
							</Container>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default G0221Question;